import React, { useEffect, useState } from "react";

import classNames from "classnames";
import { Edit } from "icons";
import { useParams } from "react-router-dom";

import dataSourcesApi from "apis/dataSource";
import { Button, PageLoader } from "clearsense-ui/components";
import AppRouteGenerator from "components/Common/AppRouteGenerator";
import CardsPanel from "components/Common/CardsPanel";
import PageNotFound from "components/Common/PageNotFound";
import { useUserState } from "contexts/user";
import filterReadableFeatures from "utils/filterReadableFeatures";

import BusinessTerms from "./BusinessTerms";
import Cde from "./Cde";
import Domains from "./Domains";
import People from "./People";
import ReferenceSources from "./ReferenceSources";

const DataSourcesExploreCards = ({
  cdesCount,
  domainsCount,
  dataSourceName,
  referenceSourcesCount,
  businessTermsCount,
  features,
  user,
}) => (
  <CardsPanel
    breadcrumbs={[
      { label: "Data Sources", link: "/management/data-sources" },
      { label: dataSourceName, link: "#" },
    ]}
    actionBlock={<Button icon={Edit} />}
    cards={[
      {
        title: "Domains",
        count: domainsCount,
        to: "domains",
      },
      {
        title: "Critical Data Elements",
        count: cdesCount,
        to: "cde",
      },
      {
        title: "Business Terms",
        count: businessTermsCount,
        to: "business-terms",
      },
      {
        title: "Reference Sources",
        count: referenceSourcesCount,
        to: "reference-sources",
      },
      {
        title: "People",
        count: 5,
        to: "people",
      },
    ].filter(card =>
      filterReadableFeatures(features, user).includes(card.title)
    )}
  />
);

const DataSourcesExplorePage = ({ features }) => {
  const [dataSource, setDataSource] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { dataSourceId } = useParams();

  const user = useUserState();

  const getDataSource = async () => {
    try {
      setIsLoading(true);
      const { data } = await dataSourcesApi.get(dataSourceId);
      setDataSource(data);
    } catch (error) {
      logger.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const CLIENT_ROUTES = {
    Domains: {
      component: Domains,
      path: "domains",
    },
    "Critical Data Elements": {
      component: Cde,
      path: "cde/*",
    },
    "Business Terms": {
      component: BusinessTerms,
      path: "business-terms",
    },
    "Reference Sources": {
      component: ReferenceSources,
      path: "reference-sources",
    },
    People: {
      component: People,
      path: "people",
    },
  };

  useEffect(() => {
    getDataSource();
  }, []);

  return (
    <>
      {isLoading && <PageLoader />}
      {!dataSource.id && !isLoading && <PageNotFound />}
      <div
        className={classNames("flex h-full my-4", {
          hidden: isLoading || !dataSource?.id,
        })}
      >
        <DataSourcesExploreCards
          cdesCount={dataSource?.cdes}
          domainsCount={dataSource?.domains}
          referenceSourcesCount={dataSource?.reference_sources}
          businessTermsCount={dataSource?.business_terms}
          dataSourceName={dataSource?.name}
          features={features}
          user={user}
        />
        {dataSource.id ? (
          <AppRouteGenerator
            CLIENT_ROUTES={CLIENT_ROUTES}
            features={features}
            dataSource={dataSource}
            dataSourceId={dataSourceId}
            getDataSource={getDataSource}
          />
        ) : (
          <PageLoader />
        )}
      </div>
    </>
  );
};

export default DataSourcesExplorePage;
